import { graphql } from './graphql/generated';

export const SYSTEM_STATUS_QUERY = graphql(`
  query SystemStatusWrapper {
    systemStatus {
      id
      active
      heading
      content
      link
      type
    }
  }
`);
